import { getResponseCMS } from '@/api/cms/base';
import { camelize } from '@/helpers/common';
import { REACT_APP_API_URL } from '@/helpers/conf';
import { CACHE_REVALIDATE_TIMEOUT, CLIENT_ENVS } from '@/helpers/constants';

interface IFetcher {
  baseURL: string;
  headers?: HeadersInit;
  transformResponse?: (data: any) => any;
}

export const fetcher =
  ({ baseURL, headers, transformResponse }: IFetcher) =>
  async <T = any>(...args: Parameters<typeof fetch>): Promise<T> => {
    try {
      const [pathname, config] = args;
      const url = `${baseURL}${pathname}`;
      const mergedHeaders = new Headers(config?.headers);
      Object.entries(headers || {}).forEach(([key, value]) =>
        mergedHeaders.set(key, value)
      );
      const response = await fetch(url, {
        ...config,
        headers: mergedHeaders,
        credentials: 'include',
        next: { revalidate: CACHE_REVALIDATE_TIMEOUT },
      });
      if (!response.ok) throw new Error(`API error: ${response.status}`);
      const json = await response.json();
      const transformedResponse = transformResponse
        ? transformResponse(json)
        : json;
      return camelize(transformedResponse) as T;
    } catch (error) {
      console.log('Error in fetcher:', error);
      throw error;
    }
  };

export const fetcherCMS = fetcher({
  baseURL: CLIENT_ENVS.CMS_URL || '',
  transformResponse: getResponseCMS,
});

export const fetcherSS = fetcher({
  baseURL: `${CLIENT_ENVS.APP_ENV === 'development' ? '' : `${REACT_APP_API_URL}`}/api`,
  headers: {
    Accept: 'application/vnd.s.v1+json',
    'Content-Type': 'application/json',
  },
});
